import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'a7-label-value',
    templateUrl: './label-value.component.html',
    styleUrls: ['./label-value.component.scss'],
    standalone: false
})
export class A7LabelValueComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  value: string;

  @Input()
  supplementary?: string;

  @Input()
  tooltip?: string;

  @Input()
  category: A7LabelValueCategory = 'VALUE_FIRST';

  @Input()
  weight: A7LabelValueWeight = 'MEDIUM';

  @Input()
  variant: A7LabelValueVariant = 'A';

  @Input()
  inverseColor: boolean = false;

  @Input() percent: number = null;

  @Input()
  primaryTextColor: string = 'color-on-surface';

  @Input()
  secondaryTextColor: string = 'color-on-surface-variant';

  @Input()
  supplementaryTextColor: string = 'color-on-surface';

  @Input()
  routerLink: string;

  @Input()
  smallerDecimal: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (this.inverseColor) {
      if (this.primaryTextColor === 'color-on-surface') {
        this.primaryTextColor = 'color-inverse-on-surface';
      }

      if (this.secondaryTextColor === 'color-on-surface-variant') {
        this.secondaryTextColor = 'color-inverse-on-surface-variant';
      }
    }
  }

  get templateId() {
    const result = `${this.category}-${this.weight}-${this.variant}`;
    return result;
  }

  get valueHasDecimal() {
    return this.value.toString().includes('.');
  }
}

type A7LabelValueCategory = 'LABEL_FIRST' | 'VALUE_FIRST' | 'COMPACT' | 'CHIP';

type A7LabelValueWeight = 'HEAVY' | 'MEDIUM' | 'LIGHT' | 'XHEAVY';

type A7LabelValueVariant = 'A' | 'B' | 'C';
